/**
 * Duo feature identity (design 5.2): the single cross-side definition of
 * the feature's name and the canonical entitlement key it carries (Duo
 * Auth API credentials, connectivity test, Duo push / MFC resolution).
 * Imported by worker/src/features/duo/module.ts and
 * frontend/src/features/duo/module.ts.
 */

import { defineIdentity } from '../featureModule'

export const identity = defineIdentity({
  name: 'duo',
  entitlements: ['duo'],
})
